<template>
    <div class="map-event-container"
         @click="$emit('show-on-map', {'devId': event.dev_id, 'index': event.index})">
        <div :class="['status', {'orange-status' : event.state === 2}, {'red-status': event.status !== 2}]"></div>
        <div>
            <div class="d-flex align-items-center">
                <div class="ml-2">{{ mapEventText }}</div>
            </div>
        </div>
        <div class="alarm-info-container d-flex justify-content-between">
            <div>
                <div class="alarm-info-item d-inline-block"><SvgIcon name="place-marker"/></div>
                <div class="alarm-info-item d-inline-block">{{ objectName }}</div>
            </div>
            <div class="alarm-info-item">{{ eventDate }}</div>
        </div>
    </div>
</template>

<script>
    // components
    import SvgIcon from '../shared/SvgIcon'
    // utils
    import {formatDate, parsedDate} from "../../utils/common";
    // mixins
    import SafeTranslateMixin from "../../mixins/SafeTranslateMixin";

    export default {
        name: "MapEvent",
        components: {
            SvgIcon
        },
        mixins: [SafeTranslateMixin],
        props: {
            event: Object
        },
        computed: {
            objectName() {
                if (this.$i18n.locale) {
                    return this.event[`name_${this.$i18n.locale}`];
                }
                return this.event['name_en'];
            },
            eventDate() {
                try {
                    const eventDateAsDateObj = parsedDate(this.event.date);
                    return formatDate(eventDateAsDateObj);
                }
                catch(e) {
                    return this.event.date;
                }
            },
            mapEventText() {
                const sensorName = this.safeTranslateValue('sensors', this.event["attrib"]);
                return sensorName;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    .map-event-container {
        position: relative;
        border-top: 1px solid #EBEBEB;
        display: block;
        background: $whiteColor 0 0 no-repeat padding-box;
        width: 100%;
        z-index: 1;
        padding: 0.5rem;
        cursor: pointer;
        &:hover {
            background-color: $veryLightGrey;
        }
    }

    .status {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 2px;
    }

    .red-status {
        border-left: 8px solid #F53D35;
    }

    .orange-status {
        border-left: 8px solid #FFC300;
    }

    .map-events-title {
        text-align: center;
        font-family: $font-family-sans-serif;
        font-weight: $font-weight-semi-bold;
        font-size: $font-size-lg;
        line-height: $font-size-lg;
        letter-spacing: 0;
        color: #6299EB;
        opacity: 1;
    }

    .alarm-info-container {
        display: flex;
        font-family: $font-family-sans-serif;
        font-size: $font-size-base;
        color: $semiDarkGrey;

        & .alarm-info-item {
            height: 20px;
            margin: 5px;
            line-height: 20px;
            vertical-align: middle;
        }

        // & .alarm-info-item:last-child {
        //     margin-left: auto;
        // }
    }
</style>